const preventDefault = (event: { preventDefault: (...args: any[]) => any }) => {
  event.preventDefault();
};

const generateSimpleID = () =>
  `${Math.random()}-${Math.random()}-${Math.random()}-${Math.random()}-${Math.random()}`;

export { preventDefault, generateSimpleID };
